// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName___5FQ6","colMin":"styles_colMin__2ENqW","colCheckbox":"styles_colCheckbox__26pHQ"};